<template lang="pug">
el-dialog(
  :visible.sync="modalAberto",
  width="880px",
  center,
  :close-on-click-modal="false",
  custom-class="modal-modelos",
  top="10vh",
  @close="close"
)
  span(slot="title")
    .titulo Modelo Técnico
    el-switch(
      v-model="status",
      active-color="#13ce66",
      inactive-color="#e4e4e4"
    )
  .corpo-modal-modelos
    .nome
      label Nome
        span *
      el-input#nome(
        v-model="nome",
        placeholder="Digite aqui...",
        :maxlength="100",
        :disabled="edicao ? true : false"
      )
      .validacao(v-if="validacaoNome") Nome Obrigatório!
    .modelo
      label Modelo Técnico
      tinymce#d1(v-model="modelo", :other_options="{ height: 350 }")
      //el-input(
        type="textarea",
        v-model="modelo",
        placeholder="Digite aqui...",
        :autosize="{ minRows: 1 }"
      //)
    .conclusao
      label Conclusão
      tinymce#d2(v-model="conclusao", :other_options="{ height: 200 }")
      //el-input(
        type="textarea",
        v-model="conclusao",
        placeholder="Digite aqui...",
        :autosize="{ minRows: 1 }"
      //)
    .procedimento
      label Procedimento
      el-select(
        v-model="valorProcedimento",
        placeholder="Selecione...",
        :loading="loadProcedimento"
      )
        el-option(
          v-for="item in procedimentos",
          :key="item.id",
          :label="item.nome",
          :value="item.id",
          :disabled="item.status == 'I' ? true : false"
        )
  span.dialog-footer(slot="footer")
    el-button(type="primary", @click="salvar", :loading="loadBtn") Salvar
</template>

<script>
import Services from "../../utils/services";

export default {
  props: ["openModal", "edicao"],

  data: () => ({
    modalAberto: false,
    novoCadastro: true,
    loadBtn: false,
    loadProcedimento: false,
    status: true,
    nome: "",
    modelo: "",
    conclusao: "",
    valorProcedimento: "",
    validacaoNome: false,
    procedimentos: [],
  }),

  watch: {
    openModal() {
      if (this.openModal) {
        this.modalAberto = true;
        this.getProcedimentos();

        if (this.edicao) {
          let e = this.edicao;
          setTimeout(() => {
            this.status = e.status === "A" ? true : false;
            this.nome = e.nome;
            this.modelo = e.modelo;
            this.conclusao = e.conclusao;
            this.valorProcedimento = e.id_procedimento;
            this.novoCadastro = false;
          }, 100);
        }
      } else this.modalAberto = false;
    },
  },

  methods: {
    close() {
      this.$emit("close", true);
      this.limpaVariaveis();
    },

    async getProcedimentos() {
      this.loadProcedimento = true;
      let filtro = [];
      filtro = await Services.get("/procedimento");
      this.procedimentos = filtro;
      if (this.procedimentos) this.loadProcedimento = false;
    },

    /* Método que salva e edita o cadastro de modelos */
    async salvar() {
      if (this.nome.length > 3) {
        this.validacaoNome = false;
        this.loadBtn = true;
        let data = JSON.stringify({
          nome: this.nome,
          modelo: this.modelo,
          status: this.status ? "A" : "I",
          conclusao: this.conclusao,
        });
        if (this.edicao) {
          /* Condição que edita o cadastro dos modelos */
          let editar = await Services.put(
            `/procedimento/${this.valorProcedimento}/modelo-tecnico/${this.edicao.id}`,
            data
          );
          if (editar) {
            this.loadBtn = false;
            this.$message({
              message: "Edição realizada com sucesso!",
              type: "success",
              duration: 2000,
            });
            setTimeout(() => {
              this.close();
              this.limpaVariaveis();
              this.$emit("atualiza", true);
            }, 2000);
          } else {
            this.loadBtn = false;
            this.$message({
              message: "Houve um erro na edição, tente novamente!",
              type: "error",
              duration: 3000,
            });
          }
        } else {
          /* Condição que efetua o cadastro de um novo paciente */
          let salvar = await Services.post(
            `/procedimento/${this.valorProcedimento}/modelo-tecnico`,
            data
          );
          if (salvar) {
            this.loadBtn = false;
            this.$message({
              message: "Cadastro realizado com sucesso!",
              type: "success",
              duration: 2000,
            });
            setTimeout(() => {
              this.close();
              this.limpaVariaveis();
              this.$emit("atualiza", true);
            }, 2000);
          } else {
            this.loadBtn = false;
            this.$message({
              message: "Houve um erro no cadastro, tente novamente!",
              type: "error",
              duration: 3000,
            });
          }
        }
      } else {
        this.validacaoNome = true;
      }
    },

    /* Metodo que limpa os campos */
    limpaVariaveis() {
      this.nome = "";
      this.modelo = "";
      this.conclusao = "";
      this.valorProcedimento = "";
      this.status = true;
      this.validacaoNome = false;
    },
  },
};
</script>

<style lang="scss">
.modal-modelos {
  border-radius: 20px;

  .el-dialog__header {
    padding-top: 50px;

    span {
      display: flex;
      align-items: center;
      justify-content: center;

      .titulo {
        font-size: 32px;
        color: #000;
        font-weight: 100;
      }

      .el-switch {
        margin-left: 20px;

        .el-switch__core {
          width: 45px !important;
          height: 25px;
          border-radius: 20px;

          &::after {
            width: 21px;
            height: 21px;
          }
        }

        &.is-checked {
          .el-switch__core {
            &::after {
              margin-left: -25px;
            }
          }
        }
      }
    }
    button.el-dialog__headerbtn {
      top: 50px;

      i {
        font-size: 33px;
      }
    }
  }

  .el-dialog__body {
    .corpo-modal-modelos {
      padding: 45px;
      box-sizing: border-box;

      label {
        font-size: 17px;
        color: #0180ff;
        font-weight: 400;

        span {
          margin-left: 3px;
          color: red;
        }
      }
      .el-input,
      .el-textarea {
        input,
        textarea {
          border-right: none;
          border-top: none;
          border-left: none;
          border-radius: 0;
          padding-left: 0;
          font-size: 22px;
          color: #000;
          font-weight: 300;
        }
      }

      .nome {
        position: relative;

        .validacao {
          position: absolute;
          font-size: 12px;
          bottom: -17px;
          color: red;
        }
      }
      .modelo,
      .conclusao {
        margin-top: 30px;
      }
      .procedimento {
        width: 100%;
        margin-top: 30px;

        .el-select {
          width: 100%;
        }
      }
    }
  }

  .el-dialog__footer {
    padding-bottom: 50px;
    padding-top: 0;

    .el-button {
      width: 180px;
      height: 60px;
      font-size: 22px;
      border-radius: 8px;
      font-weight: 300;
    }
  }
}
</style>